export const AUD_DESKTOP_BX206_SEARCH_STRING_DESKTOP = 'aud_desktop_bx206_search_string_desktop';

/**
 * @todo Удалить после завершения эксперимента
 * @description Данный функционал появился в задаче CD-253017, будет удалён в задаче CD-253242
 */
export const SNR_DESKTOP_SR135_REMOVE_POPULAR = 'snr_desktop_sr135_remove_popular';

export const EXPERIMENTS = [AUD_DESKTOP_BX206_SEARCH_STRING_DESKTOP, SNR_DESKTOP_SR135_REMOVE_POPULAR];
